import { createAction, props } from '@ngrx/store';
import { Ticket } from '../models/ticket.model';

export const fetchAllAccountTickets = createAction(
    '[Tickets]: Fetch all account tickets',
    props<{ expiredHours?: number; expiredMinutes?: number }>()
);

export const fetchAllAccountTicketsSuccess = createAction(
    '[Tickets]: Fetch all account tickets succeeded',
    props<{ tickets: Ticket[] }>()
);

export const fetchAllAccountTicketsFailed = createAction('[Tickets]: Fetch all account tickets failed');

export const fetchPaginatedAccountTickets = createAction(
    '[Tickets]: Fetch paginated account tickets',
    props<{ limit: number; page: number; expiredHours?: number; expiredMinutes?: number }>()
);
export const fetchPaginatedAccountTicketsSuccess = createAction(
    '[Tickets]: Fetch paginated account tickets succeeded',
    props<{ tickets: Ticket[]; page: number; limit: number }>()
);

export const fetchPaginatedAccountTicketsFailed = createAction('[Tickets]: Fetch paginated account tickets failed');

export const refetchAllAccountTicketPages = createAction(
    '[Tickets]: Refetch all account ticket pages',
    props<{ limit: number; expiredHours?: number; expiredMinutes?: number }>()
);

export const refetchAllAccountTicketPagesSuccess = createAction(
    '[Tickets]: Refetch all account ticket pages succeeded',
    props<{ tickets: Ticket[] }>()
);

export const refetchAllAccountTicketPagesFailed = createAction('[Tickets]: Refetch all account ticket pages failed');

export const fetchDeviceTickets = createAction(
    '[Tickets]: Fetch device tickets',
    props<{ expiredHours?: number; expiredMinutes?: number }>()
);
export const fetchDeviceTicketsSuccess = createAction(
    '[Tickets]: Fetch device tickets succeeded',
    props<{ tickets: Ticket[] }>()
);
export const fetchDeviceTicketsFailed = createAction('[Tickets]: Fetch device tickets failed');

export const fetchAccountTicketsHistory = createAction(
    '[Tickets]: Fetch account tickets history',
    props<{
        formattedFromDate: string;
        formattedToDate: string;
        includeReturnedTickets: boolean;
    }>()
);
export const fetchAccountTicketsHistorySuccess = createAction(
    '[Tickets]: Fetch account tickets history succeeded',
    props<{ tickets: Ticket[] }>()
);
export const fetchAccountTicketsHistoryFailed = createAction('[Tickets]: Fetch account tickets history failed');

export const activateTicket = createAction('[Tickets]: Activate ticket', props<{ docNum: string }>());
export const activateTicketSuccess = createAction('[Tickets]: Activate ticket success', props<{ ticket: Ticket }>());

export const reactivateTicket = createAction('[Tickets]: Reactivate ticket', props<{ docNum: string }>());
export const reactivateTicketSuccess = createAction(
    '[Tickets]: Reactivate ticket success',
    props<{ id: number; status: string; startDate: Date; endDate: Date }>()
);
export const activateTicketFailed = createAction('[Tickets]: Activate ticket failed');

export const resetAccountTickets = createAction('[Tickets]: Reset account tickets');

export const incrementPageIndex = createAction('[Tickets]: Increment page index', props<{ incrementBy: number }>());

export const resetState = createAction('[Tickets] Reset state');
